module.exports = function getResource(label, vars = []) {
    const resources = {
        free: 'FREE',
        value: 'value'

    };
    return resources[label];
};
